export default __webpack_public_path__ + "static/newsletter-1-1-60aed45cf92c98b4aee87882b9c53121.png";